import { useState } from "react";
import "./Counter.css";

const Counter = ({ onCounterChange, initialValue = 1, limit = 10, onDelete }) => {
  const [count, setCount] = useState(initialValue);

const handleDecrement = (e) => {
  e.preventDefault();

  if (count > 1) {
    const newCount = count - 1;
    setCount(newCount);
    onCounterChange(newCount);
  } else if (count === 1) {
    // Only trigger delete when count is exactly 1
    if (onDelete) {
      onDelete();
    }
  }
};


  const handleIncrement = (e) => {
    e.preventDefault();
    if (count < limit) {
      const newCount = count + 1;
      setCount(newCount);
      onCounterChange(newCount);
    }
  };

  return (
    <div className="quantity">
      {count > 1 ? <>
        <a href="#" className="quantity__minus" onClick={handleDecrement}>
          <span className="CounterCss">{count === 0 && onDelete ? "Delete" : "-"}</span>
        </a>
        <input
          name="quantity"
          type="text"
          className="quantity__input"
          value={count}
          readOnly
        />
        <a href="#" className="quantity__plus" onClick={handleIncrement}>
          <span className="CounterCss">{count < limit ? "+" : ""}</span>
        </a>
      </> :
        <a href="#" className="quantity__minus delete" onClick={handleDecrement}>
          <span className="CounterCss">Delete</span>
        </a>
      }
    </div>
  );
};

export default Counter;
